import React from "react";
import { getInitials, getAvatarColor } from "../../utility/avatarUtils";

/**
 * Avatar + name/subtitle cell — used in every admin table.
 *
 * Props:
 *   name      {string}  – display name (used for initials + colour)
 *   sub       {string}  – secondary line (email, company, etc.)
 *   color     {string}  – override background colour (hex/css)
 *   size      {"sm"|"md"} – avatar size, default "md" (36px)
 */
const AvatarCell = ({ name = "", sub = "", color, size = "md" }) => {
  const bg       = color || getAvatarColor(name);
  const initials = getInitials(name);
  const sz       = size === "sm" ? "w-8 h-8 text-xs" : "w-9 h-9 text-xs";

  return (
    <div className="flex items-center gap-2.5 min-w-0">
      <div
        className={`${sz} rounded-full flex-shrink-0 flex items-center justify-center text-white font-bold select-none`}
        style={{ backgroundColor: bg }}
      >
        {initials}
      </div>
      <div className="min-w-0">
        <p className="text-sm font-medium text-brand-text truncate">{name || "—"}</p>
        {sub && <p className="text-xs text-brand-muted truncate">{sub}</p>}
      </div>
    </div>
  );
};

export default AvatarCell;
